import styled, { css } from 'styled-components';
import variant from '@styled-system/variant';
import { CALENDAR_CELL_STATES } from '../../../../Availability/constants';
import theme from '../../../../../styles/config/theme';

const BaseCalendarDayCell = styled.button`
  cursor: pointer;
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  padding: 1px 6px;
  background-color: ${({ visible }) => (visible ? 'transparent' : theme.COLOR_GRAY_LIGHTEST)};
  border: 1px solid transparent;
  color: inherit;
  font-weight: bold;

  ${({ isSearchFormPicker }) => !isSearchFormPicker && css`
    border: 1px solid ${theme.COLOR_WHITE};
  `}

  &:disabled {
    cursor: default;
  }
`;

const CalendarDayCell = styled(BaseCalendarDayCell)(
  variant({
    variants: {
      // Variants for pitch-specific calendar
      // (when a pitch is selected)
      [CALENDAR_CELL_STATES.PITCH.AVAILABLE]: {
        background: theme.COLOR_CALENDAR_AVAILABLE,
        color: theme.COLOR_GRAY_DARK,
      },
      [CALENDAR_CELL_STATES.PITCH.SELECTED]: {
        background: theme.COLOR_CALENDAR_SELECTED,
        color: theme.COLOR_WHITE,
      },
      [CALENDAR_CELL_STATES.PITCH.SELECTED_END]: {
        background: theme.COLOR_CALENDAR_SELECTED_END,
        color: theme.COLOR_WHITE,
      },
      [CALENDAR_CELL_STATES.PITCH.BOOKED]: {
        background: theme.COLOR_CALENDAR_SELECTED,
        color: theme.COLOR_WHITE,
      },
      [CALENDAR_CELL_STATES.PITCH.FULL]: {
        background: theme.COLOR_CALENDAR_PITCH_FULL,
        color: theme.COLOR_GRAY_DARK,
        opacity: 0.6,
      },
      [CALENDAR_CELL_STATES.PITCH.SELECTED_FULL]: {
        background: theme.COLOR_BERRY_RED,
        color: theme.COLOR_WHITE,
      },
      [CALENDAR_CELL_STATES.PITCH.CONTACT_US]: {
        background: theme.COLOR_CALENDAR_AVAILABLE,
        color: theme.COLOR_GRAY_DARK,
      },
      [CALENDAR_CELL_STATES.PITCH.SELECTED_CONTACT_US]: {
        background: theme.COLOR_BERRY_RED,
        color: theme.COLOR_WHITE,
      },
      [CALENDAR_CELL_STATES.PITCH.CLOSED]: {
        background: theme.COLOR_WHITE,
        color: theme.COLOR_CALENDAR_OPAQUE_TEXT,
      },
      [CALENDAR_CELL_STATES.PITCH.DISABLED]: {
        background: theme.COLOR_WHITE,
        color: theme.COLOR_CALENDAR_OPAQUE_TEXT,
      },
      [CALENDAR_CELL_STATES.PITCH.PLAIN]: {
        background: theme.COLOR_WHITE,
        color: theme.COLOR_GRAY_DARK,
        transition: 'background 0.2s',
        ':hover': {
          background: theme.COLOR_GRAY_LIGHTEST,
        },
      },
      [CALENDAR_CELL_STATES.PITCH.BOOKED_UNSELECTED]: {
        background: theme.COLOR_CALENDAR_BOOKED_UNSELECTED,
      },
      [CALENDAR_CELL_STATES.PITCH.BOOKED_UNSELECTED_LAST]: {
        background: theme.COLOR_CALENDAR_BOOKED_UNSELECTED_LAST,
      },

      // Variants for neutral calendar
      // (when no pitch is selected)
      [CALENDAR_CELL_STATES.NEUTRAL.AVAILABLE]: {
        background: theme.COLOR_CALENDAR_AVAILABLE,
        color: theme.COLOR_GRAY_DARK,
      },
      [CALENDAR_CELL_STATES.NEUTRAL.SELECTED]: {
        background: theme.COLOR_CALENDAR_SELECTED,
        color: theme.COLOR_WHITE,
      },
      [CALENDAR_CELL_STATES.NEUTRAL.SELECTED_END]: {
        background: theme.COLOR_CALENDAR_SELECTED_END,
        color: theme.COLOR_WHITE,
      },
      [CALENDAR_CELL_STATES.NEUTRAL.BOOKED]: {
        background: theme.COLOR_CALENDAR_SELECTED,
        color: theme.COLOR_WHITE,
      },
      [CALENDAR_CELL_STATES.NEUTRAL.FULL]: {
        background: theme.COLOR_CALENDAR_SITE_FULL,
        color: theme.COLOR_GRAY_DARK,
        opacity: 0.6,
      },
      [CALENDAR_CELL_STATES.NEUTRAL.SELECTED_FULL]: {
        background: theme.COLOR_BERRY_RED,
        color: theme.COLOR_WHITE,
      },
      [CALENDAR_CELL_STATES.NEUTRAL.CONTACT_US]: {
        background: theme.COLOR_CALENDAR_AVAILABLE,
        color: theme.COLOR_GRAY_DARK,
      },
      [CALENDAR_CELL_STATES.NEUTRAL.SELECTED_CONTACT_US]: {
        background: theme.COLOR_BERRY_RED,
        color: theme.COLOR_WHITE,
      },
      [CALENDAR_CELL_STATES.NEUTRAL.CLOSED]: {
        background: theme.COLOR_WHITE,
        color: theme.COLOR_CALENDAR_OPAQUE_TEXT,
      },
      [CALENDAR_CELL_STATES.NEUTRAL.DISABLED]: {
        background: theme.COLOR_WHITE,
        color: theme.COLOR_CALENDAR_OPAQUE_TEXT,
      },
      [CALENDAR_CELL_STATES.NEUTRAL.PLAIN]: {
        background: theme.COLOR_WHITE,
        color: theme.COLOR_GRAY_DARK,
        transition: 'background 0.2s',
        ':hover': {
          background: theme.COLOR_GRAY_LIGHTEST,
        },
      },
      [CALENDAR_CELL_STATES.NEUTRAL.BOOKED_UNSELECTED]: {
        background: theme.COLOR_CALENDAR_BOOKED_UNSELECTED,
      },
      [CALENDAR_CELL_STATES.NEUTRAL.BOOKED_UNSELECTED_LAST]: {
        background: theme.COLOR_CALENDAR_BOOKED_UNSELECTED_LAST,
      },
    },
  }),
);

export default CalendarDayCell;
